'use client';

import { useCallback } from 'react';
import { useDeferredClientComponent } from '../../shared/use-deferred-client-component';
import type { CmsContactFormCopy } from './contact-form-panel.types';

type ContactFormPanelClientComponent = typeof import(
  './contact-form-panel.client'
).CmsContactFormPanelClient;

export function CmsContactFormPanelClientLoader({
  copy,
  locale,
}: {
  copy: CmsContactFormCopy;
  locale: string;
}) {
  const loadComponent = useCallback(
    () =>
      import('./contact-form-panel.client').then(
        (module) => module.CmsContactFormPanelClient
      ),
    []
  );
  const resolveTarget = useCallback(
    (host: HTMLElement) => host.parentElement?.previousElementSibling ?? host,
    []
  );
  const { Component, hostRef, load } =
    useDeferredClientComponent<ContactFormPanelClientComponent>(loadComponent, {
      resolveTarget,
    });

  return (
    <div
      ref={hostRef}
      data-cms-deferred-client-loaded={Component ? 'true' : 'false'}
      onPointerEnter={load}
      onFocusCapture={load}
    >
      {Component ? <Component copy={copy} locale={locale} /> : null}
    </div>
  );
}
